import React from 'react';
import { Button } from '../ui/button';
import { ArrowRight, Sparkles } from 'lucide-react';

const HeroSection = () => {
  return (
    <section 
      data-testid="hero-section" 
      className="relative min-h-screen flex items-center bg-[#EDE7E1] overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://images.unsplash.com/photo-1730838199493-19d469f7ee62?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHxlbGVnYW50JTIwd29tYW4lMjBmYXNoaW9uJTIwbW9kZWwlMjBzdHJlZXQlMjBzdHlsZSUyMGJlaWdlJTIwY29hdHxlbnwwfHx8fDE3NzM0MDA2NDB8MA&ixlib=rb-4.1.0&q=85"
          alt="Mujer elegante con estilo"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#EDE7E1]/95 via-[#EDE7E1]/70 to-transparent" />
      </div>

      {/* Content */}
      <div className="container-custom relative z-10 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center py-20 lg:py-0">
        <div className="max-w-xl animate-fade-in-up">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-white/80 backdrop-blur-sm px-4 py-2 rounded-full mb-8">
            <Sparkles className="w-4 h-4 text-[#C8A96A]" />
            <span className="text-sm font-sans tracking-wide text-[#111111]">Colección Exclusiva</span>
          </div>

          {/* Headline */}
          <h1 
            data-testid="hero-headline"
            className="font-serif text-5xl md:text-6xl lg:text-7xl font-bold text-[#111111] leading-tight mb-6"
          >
            Moda de marca<br />
            <span className="text-[#C8A96A]">para mujer</span>
          </h1>

          {/* Subheadline */}
          <p className="text-xl md:text-2xl font-serif italic text-[#111111]/80 mb-6">
            Elegante, actual y a precios outlet
          </p>

          {/* Description */}
          <p className="text-base md:text-lg font-sans text-[#111111]/70 mb-8 leading-relaxed">
            Descubre las colecciones de <strong>Trucco</strong> y <strong>Naelle</strong> con descuentos exclusivos online.
          </p>

          {/* Bullets */}
          <ul className="space-y-3 mb-10">
            {[
              'Moda femenina elegante y actual',
              'Prendas versátiles para oficina y diario',
              'Calidad de marca a precio outlet'
            ].map((item, index) => (
              <li key={index} className="flex items-center gap-3 text-[#111111]/80">
                <span className="w-2 h-2 bg-[#C8A96A] rounded-full" />
                <span className="font-sans">{item}</span>
              </li>
            ))}
          </ul>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4">
            <a 
              href="https://styleoutlet.es" 
              target="_blank" 
              rel="noopener noreferrer"
              data-testid="hero-cta-primary"
            >
              <Button className="bg-[#C8A96A] hover:bg-[#111111] text-white px-8 py-6 text-base font-bold tracking-widest uppercase transition-all duration-300 cursor-pointer">
                Descubrir la colección
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
            </a>
            <a 
              href="https://styleoutlet.es/41-vestidos" 
              target="_blank" 
              rel="noopener noreferrer"
              data-testid="hero-cta-secondary"
            >
              <Button variant="outline" className="border-2 border-[#111111] text-[#111111] hover:bg-[#111111] hover:text-white px-8 py-6 text-base font-bold tracking-widest uppercase transition-all duration-300 cursor-pointer">
                Ver vestidos más vendidos
              </Button>
            </a>
          </div>
        </div>

        {/* Right side - decorative elements (hidden on mobile) */}
        <div className="hidden lg:block" />
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-[#111111]/30 rounded-full flex justify-center pt-2">
          <div className="w-1 h-3 bg-[#C8A96A] rounded-full" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
